import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import locale from "@amcharts/amcharts4/lang/pt_BR.js";
import imgAlerta from "../../assets/images/triangle.png";

function montarGraficoHorizontalStackedBar({
    component,
    chartDivId,
    category,
    valuesAndNames = [],
    bulletColor = "#FFF",
    bulletColorIn = "#FFF",
    lista = [],
    titulo = "",
    prefixo = "R$",
    sufixo = "",
    bullets = false,
    maxWidthLabel = null,
    wrapTextLabel = false,
    cores = null,
    campoSetVisible,
}) {
    //se não vier uma serie sai da função
    if (valuesAndNames[0] && !valuesAndNames[0].value) return;
    if (component) component.dispose();

    am4core.useTheme(am4themes_animated);

    const chart = am4core.create(chartDivId, am4charts.XYChart);

    chart.language.locale = locale;

    if (titulo) {
        let title = chart.titles.create();
        title.text = titulo;
        title.fontSize = 16;
        title.marginBottom = 30;
    }

    chart.exporting.menu = new am4core.ExportMenu();
    chart.exporting.filePrefix = "Gráfico";
    chart.exporting.menu.align = "right";
    chart.exporting.menu.verticalAlign = "top";
    chart.exporting.menu.items = [
        {
            label: "...",
            menu: [
                {
                    type: "png",
                    label: "PNG",
                },
            ],
        },
    ];

    chart.language.locale["_decimalSeparator"] = ",";
    chart.language.locale["_thousandSeparator"] = ".";
    chart.numberFormatter.numberFormat = "###,###,###,###.00";

    //----------------------------------------------------
    chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

    chart.colors.step = 1; // garante que cada série pegue uma cor diferente
    if (cores) {
        chart.colors.list = cores;
    }

    chart.data = [...lista];
    const categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.dataFields.category = category;
    categoryAxis.renderer.minGridDistance = 20;
    categoryAxis.renderer.minWidth = 120;
    categoryAxis.renderer.labels.template.fontSize = 12;
    categoryAxis.renderer.labels.template.textAlign = "right";
    categoryAxis.renderer.labels.template.fill = am4core.color("#FFF"); //cor do texto eixo x

    // Limitar o texto do eixo Y a 20 caracteres com quebra de linha
    categoryAxis.renderer.labels.template.wrap = !!wrapTextLabel; // Ativar a quebra de linha
    categoryAxis.renderer.labels.template.maxWidth = maxWidthLabel || 300; // Definir a largura máxima permitida

    // Limitar o texto do eixo Y a 20 caracteres com quebra de linha
    categoryAxis.renderer.labels.template.adapter.add("textOutput", (text) => {
        if (text && text.length > 40) {
            return text.substring(0, 40) + "...";
        }
        return text;
    });

    const valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
    valueAxis.paddingBottom = 30;
    valueAxis.renderer.maxLabelPosition = 0.98;
    valueAxis.renderer.labels.template.fontSize = 12;
    valueAxis.renderer.labels.template.textAlign = "middle";
    valueAxis.renderer.labels.template.fill = am4core.color("#FFF"); //cor do texto eixo x
    // valueAxis.min = 0; // Define o valor mínimo do eixo X como 0
    // 🔹 Reserva 15% do espaço à direita (as barras ocupam no máx. 85%)
    valueAxis.extraMax = 0.15;

    valueAxis.stacked = true;

    // Remover tooltips dos eixos
    categoryAxis.tooltip.disabled = true;
    valueAxis.tooltip.disabled = true;

    valuesAndNames.forEach((vn, idx) => {
        createSeries(vn.value, vn.name, vn.stacked, idx === valuesAndNames.length - 1);
    });

    function createSeries(value, name, stacked = false, isLastSeries) {
        const series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.categoryY = category;
        series.dataFields.valueX = value;
        series.dataFields.valueXBullet = value + "_bullet";
        series.name = name;
        series.stacked = stacked;
        series.tooltipText = `{categoryY}:\n [bold]${prefixo} {valueX.formatNumber("###,###,###,###.00")} ${sufixo} ({name})[/]`;

        // 🔹 Mostra aviso extra só quando for "Consumo Instantâneo" e o valueX < 0
        series.adapter.add("tooltipText", (text, target) => {
            const dataItem = target.tooltipDataItem;
            if (!dataItem || !dataItem.dataContext) return text;
            const serieNome = series.name;
            const valueX = Number(dataItem.dataContext[value] || 0);

            // 🔹 Se a UC não for geradora e a série for "Consumo Instantâneo", não mostra tooltip
            if (serieNome === "Consumo Instantâneo" && campoSetVisible && !dataItem.dataContext[campoSetVisible]) {
                return ""; // oculta completamente o tooltip
            }

            if (serieNome === "Consumo Instantâneo" && valueX < 0) {
                text +=
                    "\n[bold #f21f6c]Verificar consumo instantâneo negativo:[/] possivelmente há discordância ou erro no período de leitura da fatura pela concessionária de energia";
            }

            return text;
        });

        // Defina um limite de largura e habilite a quebra de linha no tooltip
        series.tooltip.maxWidth = 300; // Define a largura máxima do tooltip em pixels
        series.tooltip.label.wrap = true; // Ativa a quebra de linha
        series.tooltip.label.truncate = false; // Evita que o texto seja truncado

        series.sequencedInterpolation = true;
        series.sequencedInterpolationDelay = 100;
        series.columns.template.strokeOpacity = 0;

        // Definir altura mínima da barra
        series.columns.template.maxHeight = 50; // Defina a altura mínima desejada em pixels

        chart.cursor = new am4charts.XYCursor();
        // chart.cursor.behavior = "zoomY";

        // as by default columns of the same series are of the same color, we add adapter which takes colors from chart.colors color set
        // series.columns.template.adapter.add("fill", (fill, target) => {
        //     return chart.colors.getIndex(target.dataItem.index);
        // });

        if (bullets) {
            // Bullet interno em cada segmento
            const internalBullet = series.bullets.push(new am4charts.LabelBullet());
            internalBullet.label.text = `{valueX.formatNumber("###,###.00")} ${sufixo} ({name})`;
            internalBullet.label.fill = am4core.color(bulletColorIn);
            internalBullet.label.fontSize = 12;
            internalBullet.label.dx = -5; // dentro da barra
            internalBullet.label.fontWeight = "bold";
            internalBullet.label.horizontalCenter = "right";
            internalBullet.label.truncate = false;
            internalBullet.label.wrap = false;
            internalBullet.label.maxWidth = 9999;

            internalBullet.label.adapter.add("text", (text, target) => {
                const dataItem = target.dataItem;
                if (!dataItem) return "";

                const columnWidth = dataItem.column.pixelWidth;
                const value = Number(dataItem.values.valueX.value || 0);

                // Se a barra for pequena ou o valor <= 0, não mostra texto
                if (columnWidth < 120 || value <= 0) return "";

                // Monta o texto manualmente (evita mostrar {valueX.formatNumber})
                const nomeSerie = dataItem.component.name || "";
                let textoFormatado = `${value.toLocaleString("pt-BR", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                })} kWh (${nomeSerie})`;

                // Substitui palavras longas
                textoFormatado = textoFormatado.replace(/Consumo/gi, "Cons.").replace(/Instantâneo/gi, "Inst.");

                const labelWidth = target.measuredWidth || textoFormatado.length * 6;

                // Se o texto for maior que a barra, corta antes do parêntese
                if (labelWidth > columnWidth - 50) {
                    const indiceParentesesInicial = textoFormatado.indexOf("(");
                    if (indiceParentesesInicial > 0) {
                        textoFormatado = textoFormatado.substring(0, indiceParentesesInicial).trim();
                    }
                }

                return textoFormatado;
            });

            // 🔹 Adiciona bullet de alerta (imagem) para negativos
            const alertBullet = series.bullets.push(new am4charts.Bullet());
            const alertImage = alertBullet.createChild(am4core.Image);
            alertImage.href = imgAlerta;
            alertImage.width = 16;
            alertImage.height = 16;
            alertImage.horizontalCenter = "right"; // fica na borda esquerda da barra negativa
            alertImage.verticalCenter = "middle";
            alertBullet.adapter.add("dx", (dx, target) => {
                const dataItem = target.dataItem;
                if (!dataItem) return dx;

                const value = Number(dataItem.values.valueX.value || 0);
                const nomeSerie = dataItem.component.name || "";

                if (nomeSerie === "Consumo Instantâneo" && value < 0) {
                    return -10; // desloca para a esquerda da barra negativa
                }
                return 9999; // posiciona fora da tela se não for negativo
            });

            internalBullet.label.adapter.add("dx", (dx, target) => {
                const dataItem = target.dataItem;
                if (!dataItem || !dataItem.column) return dx;

                const columnWidth = dataItem.column.pixelWidth;
                const labelWidth = target.measuredWidth;

                // 🔹 Se o label for maior que a barra, limita o dx para caber dentro
                if (labelWidth > columnWidth - 4) {
                    // 4px de padding interno
                    return -(labelWidth - columnWidth + 4) / 2; // centraliza dentro da barra
                }

                // 🔹 Se o label for menor que a barra, centraliza normalmente
                return dx;
            });

            // Bullet total fora da barra (somente na última série)
            if (isLastSeries) {
                const totalBullet = series.bullets.push(new am4charts.LabelBullet());
                totalBullet.label.fill = am4core.color(bulletColor);
                totalBullet.label.fontWeight = "bold";
                totalBullet.label.fontSize = 12;
                totalBullet.label.truncate = false;
                totalBullet.label.wrap = false;
                totalBullet.label.horizontalCenter = "left";
                totalBullet.locationX = 1; // coloca no final da pilha
                totalBullet.dy = 0;
                totalBullet.dx = 5;

                chart.maskBullets = false; // permite bullets fora do gráfico

                totalBullet.label.adapter.add("text", (text, target) => {
                    const dataItem = target.dataItem;
                    if (!dataItem) return "";

                    const categoryValue = dataItem.categoryY;

                    // Soma apenas os valores POSITIVOS da categoria
                    const totalPositivo = valuesAndNames.reduce((acc, vn) => {
                        const item = lista.find((l) => l[category] === categoryValue);
                        const v = item ? Number(item[vn.value]) || 0 : 0;
                        return v > 0 ? acc + v : acc;
                    }, 0);

                    // Soma apenas os valores NEGATIVOS da categoria
                    const totalNegativo = valuesAndNames.reduce((acc, vn) => {
                        const item = lista.find((l) => l[category] === categoryValue);
                        const v = item ? Number(item[vn.value]) || 0 : 0;
                        return v < 0 ? acc + v : acc;
                    }, 0);

                    // Guarda o total (positivo + negativo)
                    dataItem.dataContext._totalPositivo = totalPositivo;
                    dataItem.dataContext._totalNegativo = totalNegativo;

                    // Mostra o total geral
                    const total = totalPositivo;
                    return `${prefixo} ${total.toLocaleString("pt-BR", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    })} ${sufixo}`;
                });

                // 🔹 Ajuste de posição (fora da pilha positiva)
                totalBullet.adapter.add("x", (x, target) => {
                    const dataItem = target.dataItem;
                    if (!dataItem || !dataItem.component) return x;

                    const series = dataItem.component;
                    const col = dataItem.column;

                    if (!col) return x;

                    const totalPos = dataItem.dataContext._totalPositivo || 0;
                    const totalNeg = dataItem.dataContext._totalNegativo || 0;

                    // 🔸 Calcula posição X final da pilha positiva
                    let totalX = 0;

                    if (totalPos > 0) {
                        totalX = series.xAxis.valueToPosition(totalPos) * series.xAxis.axisFullLength;
                    } else {
                        // Se não há positivos, usa o final da pilha negativa
                        totalX = series.xAxis.valueToPosition(totalNeg) * series.xAxis.axisFullLength;
                    }

                    return totalX + (totalPos > 0 ? 0 : -10);
                });
            }
        }
    }
    return chart;
}
export { montarGraficoHorizontalStackedBar };
